// extracted by mini-css-extract-plugin
module.exports = {"button_wrapper":"NoConnectionError_button_wrapper__1xH2D","button_reload":"NoConnectionError_button_reload__2U2kl"};